import React, { useState } from 'react';

import { mixpanelObject } from 'src/utils/analytics';

import AccordionItem from './accordionItem/AccordionItem';
import { IAccordion } from './types';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_EXPAND_DESCRIPTION,
  MIXPANEL_COLLAPSE_DESCRIPTION
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { popupCTAEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

const AccordionList: React.FC<IAccordion> = ({
  accordionContents,
  showLessIcon,
  showMoreIcon
}) => {
  const [collapsibleContent, setCollapsibleContent] = useState<number | null>(
    null
  );

  const expandDescriptionMixpanelEvent = () => {
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_EXPAND_DESCRIPTION);
    popupCTAEvent();
  };

  const collapseDescriptionMixpanelEvent = () => {
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_COLLAPSE_DESCRIPTION);
    popupCTAEvent();
  };

  const collapsibleCallback = (id: number) => {
    if (collapsibleContent === id) {
      setCollapsibleContent(null);
      collapseDescriptionMixpanelEvent();
    } else {
      if (collapsibleContent !== null) {
        collapseDescriptionMixpanelEvent();
      }
      setCollapsibleContent(id);
      expandDescriptionMixpanelEvent();
    }
  };

  const renderAccordionItems = accordionContents.map((content, index) => {
    return (
      <AccordionItem
        key={index}
        {...content}
        id={index}
        collapsibleContent={collapsibleContent}
        collapsibleCallback={collapsibleCallback}
        showLessIcon={showLessIcon}
        showMoreIcon={showMoreIcon}
      />
    );
  });

  return <div>{renderAccordionItems}</div>;
};

export default AccordionList;
